module.exports = __webpack_public_path__ + "media/site/fonts/TheNorthernBlockLtd-NeoGramCondensed-Light-1c5f1454f4ad0430acd136e075126d91.otf";